import { RouteConfig, RouteId } from 'types';
import { FAVORITES, FAVORITES_PLAINTEXT, getAssessmentAcceleratorTitle } from '../util';
import Resources from '../Resources';
import AssessmentAcceleratorPreview from '../AssessmentAcceleratorPreview';
import WeeksLessonPreview from '../LessonPreviewGradeDetails';
import WeekLessonPreviewDetails from '../LessonPreviewWeekDetails';
import {
  getBreadcrumbs,
  getAssessmentAcceleratorBreadcrumbs,
  getResourceProductCurriculumBreadcrumbs,
  getResourceProductCurriculumWeekBreadcrumbs,
  getResourceTypeById,
  DEFAULT_NAME
} from './breadcrumbs-util';

const routes: RouteConfig[] = [
  {
    Component: Resources,
    getTitle: (props): string => {
      if (props?.match?.params?.resourceTypeId === FAVORITES) return FAVORITES_PLAINTEXT;
      const result = getResourceTypeById(
        props?.client as any,
        +props?.match?.params?.resourceTypeId
      );

      return result?.resourceType?.title ?? DEFAULT_NAME;
    },
    path: '/resources/:resourceTypeId',
    id: RouteId.RESOURCES,
    privileges: [],
    getBreadcrumbs
  },
  {
    Component: AssessmentAcceleratorPreview,
    getTitle: props => getAssessmentAcceleratorTitle(props?.match?.params?.productCurriculumCode),
    path: '/resources/5/:productCurriculumCode',
    id: RouteId.ASSESSMENT_ACCELERATOR_PREVIEW,
    privileges: [],
    getBreadcrumbs: getAssessmentAcceleratorBreadcrumbs
  },
  {
    Component: WeeksLessonPreview,
    getTitle: () => '36 Week Lesson Preview',
    path: '/resources/:resourceTypeId/:productCurriculumCode',
    id: RouteId.LESSON_GRADE_PREVIEW,
    privileges: [],
    getBreadcrumbs: getResourceProductCurriculumBreadcrumbs
  },
  {
    Component: WeekLessonPreviewDetails,
    getTitle: props => `Week ${props?.match?.params?.week} Details`,
    path: '/resources/:resourceTypeId/:productCurriculumCode/:week',
    id: RouteId.LESSON_WEEK_PREVIEW,
    privileges: [],
    getBreadcrumbs: getResourceProductCurriculumWeekBreadcrumbs
  }
];

const getRoutes = (): RouteConfig[] => routes;

export default getRoutes;
